import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.create-ideas.title.non-final',
		defaultMessage: 'Create ideas',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.create-ideas.description.non-final',
		defaultMessage: 'Create new ideas separately, in bulk, or import existing ones using a form.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	roleRestrictionsText: {
		id: 'polaris-components-quickstart.tasks.create-ideas.role-restrictions-text.non-final',
		defaultMessage: "Contributors can't create ideas in bulk or import ideas.",
		description: 'Text describing role restrictions',
	},
});
